/* <cr-shop-the-look> — mockup script.js:297-337 (renderLook / openSpot / closePops).
   Quick view buttons use the Phase 1 quick view (CR.quickView). */
if (!customElements.get('cr-shop-the-look')) {
  customElements.define('cr-shop-the-look', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.cr-look__tab'));
      this.boards = Array.from(this.querySelectorAll('[data-look-board]'));
      this.lists = Array.from(this.querySelectorAll('[data-look-list]'));
      this.cur = 0;

      this.tabs.forEach((t, k) => t.addEventListener('click', () => { this.closePops(); this.render(k); }));
      this.addEventListener('click', (e) => {
        const qv = e.target.closest('[data-cr-look-qv]');
        if (qv) { if (window.CR && window.CR.quickView) window.CR.quickView.open(qv.dataset.crLookQv, { trigger: qv }); return; }
        const close = e.target.closest('[data-pop-close]');
        if (close) { e.stopPropagation(); const spot = this.openSpotEl; this.closePops(); if (spot) spot.focus(); return; }
        const h = e.target.closest('.cr-hotspot');
        if (h) { if (h.getAttribute('aria-expanded') === 'true') this.closePops(); else this.openSpot(+h.dataset.spot); }
      });
      // js:336 — hovering a list row shows its hotspot popup
      this.lists.forEach((list) => list.addEventListener('mouseover', (e) => {
        const row = e.target.closest('.cr-look__item');
        if (row && !row.classList.contains('is-active')) this.openSpot(+row.dataset.row);
      }));
      // js:337 — click outside the board and list closes
      this.onDocClick = (e) => { if (!e.target.closest('.cr-look__board') && !e.target.closest('.cr-look__list')) this.closePops(); };
      document.addEventListener('click', this.onDocClick);
      this.onEscape = () => this.closePops();
      document.addEventListener('cr:escape', this.onEscape);

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (e) => { const k = this.tabs.indexOf(e.target); if (k > -1) { this.closePops(); this.render(k); } };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('cr:escape', this.onEscape);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    render(k) {
      this.cur = k;
      this.tabs.forEach((t, j) => t.setAttribute('aria-selected', j === k ? 'true' : 'false'));
      this.boards.forEach((b, j) => { b.hidden = j !== k; });
      this.lists.forEach((l, j) => { l.hidden = j !== k; });
    }

    closePops() {
      this.querySelectorAll('[data-pop]').forEach((p) => {
        p.hidden = true;
        if (p._home && p.parentElement !== p._home) p._home.appendChild(p); // back into its photo
      });
      this.querySelectorAll('.cr-hotspot').forEach((h) => h.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('.cr-look__item').forEach((li) => li.classList.remove('is-active'));
      this.openSpotEl = null;
    }

    // js:316-329
    openSpot(n) {
      this.closePops();
      const board = this.boards[this.cur].querySelector('.cr-look__board');
      const photo = board.querySelector('[data-spot-photo="' + n + '"]');
      if (!photo) return;
      const spot = photo.querySelector('.cr-hotspot');
      const pop = photo.querySelector('[data-pop]');
      const x = parseFloat(photo.dataset.x), y = parseFloat(photo.dataset.y);
      const photos = board.querySelectorAll('[data-spot-photo]');
      spot.setAttribute('aria-expanded', 'true');
      const leftSide = x > 50 || (n === photos.length - 1 && window.innerWidth > 749);
      pop.style.top = 'calc(' + y + '% + 24px)';
      pop.style.left = leftSide ? 'calc(' + x + '% - 236px)' : 'calc(' + x + '% - 24px)';
      pop._home = photo;
      if (window.innerWidth <= 749) board.appendChild(pop); // mobile: pinned to the bottom of the board (CSS)
      pop.hidden = false;
      this.openSpotEl = spot;
      const row = this.lists[this.cur].querySelector('[data-row="' + n + '"]');
      if (row) row.classList.add('is-active');
    }
  });
}
